<template>
  <div class="d-flex align-items-start">
    <div class="d-flex half-width mr-3">
      <TextField
        v-model="phone"
        v-mask="'(###) ###-####'"
        label-class="flex-grow-1"
        input-class="ss-input-group-prepend"
        :validation-errors="v$.$errors"
        v-bind="$attrs"
        data-vv-as="Phone"
        name="phone"
        :label="name"
        placeholder="Phone"
        no-label
        data-cy="phone-number-input"
      />
      <Select
        v-model="type"
        :options="options"
        placeholder="--"
        :name="`${modelValue?.id}-phone-type`"
        style="width: 85px"
        data-vv-as="Type"
        no-label
        body-render
        :select-options-style-default="{ 'z-index': 1041 }"
        input-class="ss-input-group-append"
        data-cy="phone-type-select"
      />
    </div>
    <div class="d-flex flex-1">
      <TextField
        v-model="label"
        v-bind="$attrs"
        label-class="flex-1"
        data-vv-as="Label"
        :name="`${modelValue.id}-phone-label`"
        placeholder="Label (Optional)"
        no-label
        data-cy="phone-type-select"
      />
      <div
        v-if="!hideButtons && !hideSetPrimary"
        class="icon-button ml-1"
        :class="{
          'cursor-pointer': !primary,
          'icon-margin-right': primary
        }"
        data-cy="phone-primary-toggle-icon"
        v-on="!primary ? { click: handleClickPrimary } : {}"
      >
        <i
          class="fa-star"
          :class="{
            fal: !primary,
            fas: primary
          }"
        >
        </i>
      </div>
      <div
        v-if="!hideButtons && !primary && canDelete"
        class="icon-button cursor-pointer ml-1"
        data-cy="phone-delete-icon"
        @click="$emit('delete-phone', modelValue)"
      >
        <i class="fas fa-trash-alt"></i>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, minLength, required } from "@vuelidate/validators";

export default {
  components: {
    TextField
  },
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: Object,
      default: null
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: null
    },
    hideButtons: {
      type: Boolean,
      default: false
    },
    hideSetPrimary: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "delete-phone", "set-primary"],
  emits: ["delete-phone", "update:modelValue", "set-primary"],
  validations() {
    return {
      phone: {
        required: helpers.withMessage("Phone is required", required),
        minLength: minLength(9),
        $autoDirty: true
      }
    };
  },
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      phone: "",
      type: "",
      label: "",
      options: [
        {
          label: "Mobile",
          value: "mobile"
        },
        {
          label: "Home",
          value: "home"
        },
        {
          label: "Work",
          value: "work"
        }
      ]
    };
  },
  watch: {
    phone(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          phone_number: newValue
        });
      }
    },
    type(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          type: newValue
        });
      }
    },
    label(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          label: newValue
        });
      }
    },
    modelValue(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.phone = newValue.phone_number;
        this.type = newValue.type;
        this.label = newValue.label;
      }
    }
  },
  created() {
    if (this.modelValue) {
      this.phone = this.modelValue.phone_number || "";
      this.type = this.modelValue.type || "";
      this.label = this.modelValue.label || "";
    }
  },
  methods: {
    handleClickPrimary() {
      this.$emit("set-primary", this.modelValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35px;
  min-width: 25px;
  i {
    font-size: 1rem;
  }
}

.flex-grow-1 {
  flex-grow: 1;
}
</style>
